module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Moviles-2-zoom.653e7ead.png";